/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import { Route, Switch, BrowserRouter} from 'react-router-dom'
import { PATHS } from '../../../global/constants'
import DailyPlan from './dailyPlan'
import MakePlan from './makePlan'

export default function PlanRoute() {
  return (
    <>
    <BrowserRouter>
    <Switch>
      <Route path={PATHS.admin.name+PATHS.dailyPlan.name} exact component={DailyPlan}/>
      <Route path={PATHS.admin.name+PATHS.dailyPlan.makePlan.name} exact component={MakePlan}/>
    </Switch>
    </BrowserRouter>
    </>
  )
}
